exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-278db934] {\n  margin-top: 30px;\n}\n.fee-input[data-v-278db934] {\n  max-width: 50px;\n}\n.fee-input[data-v-278db934]::-webkit-inner-spin-button,\n.fee-input[data-v-278db934]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}", ""]);

// exports
